export var DownloadsApiErrors;
(function (DownloadsApiErrors) {
    class DownloadsApiProcedureError extends Error {
        status;
        procedureName;
        scope;
        body;
        constructor(args) {
            super(args.message);
            this.name = args.name;
            this.status = args.status;
            this.procedureName = args.procedureName;
            this.scope = args.scope;
            this.body = args.body;
            Object.setPrototypeOf(this, new.target.prototype);
        }
    }
    DownloadsApiErrors.DownloadsApiProcedureError = DownloadsApiProcedureError;
    class ProcedureValidationError extends DownloadsApiProcedureError {
        static errorName = 'ProcedureValidationError';
        static statusCode = 400;
        static fromResponse(body, meta) {
            const message = body && typeof body.message === 'string'
                ? body.message
                : 'ProcedureValidationError';
            return new ProcedureValidationError({
                name: 'ProcedureValidationError',
                message,
                status: meta.status,
                procedureName: meta.procedureName,
                scope: meta.scope,
                body,
            });
        }
    }
    DownloadsApiErrors.ProcedureValidationError = ProcedureValidationError;
    class ProcedureYieldValidationError extends DownloadsApiProcedureError {
        static errorName = 'ProcedureYieldValidationError';
        static statusCode = 500;
        static fromResponse(body, meta) {
            const message = body && typeof body.message === 'string'
                ? body.message
                : 'ProcedureYieldValidationError';
            return new ProcedureYieldValidationError({
                name: 'ProcedureYieldValidationError',
                message,
                status: meta.status,
                procedureName: meta.procedureName,
                scope: meta.scope,
                body,
            });
        }
    }
    DownloadsApiErrors.ProcedureYieldValidationError = ProcedureYieldValidationError;
    class ProcedureError extends DownloadsApiProcedureError {
        static errorName = 'ProcedureError';
        static statusCode = 500;
        static fromResponse(body, meta) {
            const message = body && typeof body.message === 'string'
                ? body.message
                : 'ProcedureError';
            return new ProcedureError({
                name: 'ProcedureError',
                message,
                status: meta.status,
                procedureName: meta.procedureName,
                scope: meta.scope,
                body,
            });
        }
    }
    DownloadsApiErrors.ProcedureError = ProcedureError;
    class ProcedureRegistrationError extends DownloadsApiProcedureError {
        static errorName = 'ProcedureRegistrationError';
        static statusCode = 500;
        static fromResponse(body, meta) {
            const message = body && typeof body.message === 'string'
                ? body.message
                : 'ProcedureRegistrationError';
            return new ProcedureRegistrationError({
                name: 'ProcedureRegistrationError',
                message,
                status: meta.status,
                procedureName: meta.procedureName,
                scope: meta.scope,
                body,
            });
        }
    }
    DownloadsApiErrors.ProcedureRegistrationError = ProcedureRegistrationError;
    DownloadsApiErrors.DownloadsApiErrorRegistry = {
        ProcedureValidationError,
        ProcedureYieldValidationError,
        ProcedureError,
        ProcedureRegistrationError,
    };
})(DownloadsApiErrors || (DownloadsApiErrors = {}));
//# sourceMappingURL=_errors.js.map